"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty2(e, r, t) { return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n2 = 0, F = function F() {}; return { s: F, n: function n() { return _n2 >= r.length ? { done: !0 } : { done: !1, value: r[_n2++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["exposition"];
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.VariationConfiguration = void 0;
var _tsRes = require("ts-res"),
  _hasher = require("../hasher"),
  _kameleoonError = require("../kameleoonError"),
  _utilities = require("../utilities"),
  _types = require("../clientConfiguration/types"),
  _types2 = require("../types"),
  _logging = require("../logging");
function _objectWithoutProperties(a, b) {
  if (null == a) return {};
  var c,
    d,
    e = _objectWithoutPropertiesLoose(a, b);
  if (Object.getOwnPropertySymbols) {
    var f = Object.getOwnPropertySymbols(a);
    for (d = 0; d < f.length; d++) c = f[d], b.includes(c) || {}.propertyIsEnumerable.call(a, c) && (e[c] = a[c]);
  }
  return e;
}
function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c = {};
  for (var d in a) if ({}.hasOwnProperty.call(a, d)) {
    if (b.includes(d)) continue;
    c[d] = a[d];
  }
  return c;
}
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var VariationConfiguration = /*#__PURE__*/function () {
  function VariationConfiguration(a, b, c, d, e) {
    _classCallCheck(this, VariationConfiguration);
    _defineProperty(this, "storage", void 0), _defineProperty(this, "storageForcedExperimentVariations", void 0), _defineProperty(this, "storageForcedFeatureVariations", void 0), _defineProperty(this, "visitorCodeManager", void 0), _defineProperty(this, "clientConfiguration", void 0), this.storage = a, this.storageForcedExperimentVariations = b, this.storageForcedFeatureVariations = c, this.visitorCodeManager = d, this.clientConfiguration = e, d.setVariationConfiguration(this);
  }
  return _createClass(VariationConfiguration, [{
    key: "updateDataStatus",
    value: function updateDataStatus(a) {
      var b = a.visitorCode,
        c = a.experimentIdList,
        d = a.status;
      var e = this.storage.read();
      if (!e.ok) return e;
      var f = e.data;
      f[b] || (f[b] = {});
      var _iterator = _createForOfIteratorHelper(c),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          f[b][_e] = _objectSpread(_objectSpread({}, f[b][_e]), {}, {
            status: d
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return this.storage.write(f);
    }
  }, {
    key: "getUnsentData",
    value: function getUnsentData(a) {
      return this.getVariationData(a, function (a) {
        return a === _types2.TrackingStatus.Unsent;
      });
    }
  }, {
    key: "getPendingData",
    value: function getPendingData(a) {
      return this.getVariationData(a, function (a) {
        return a === _types2.TrackingStatus.Pending;
      });
    }
  }, {
    key: "getStoredVariations",
    value: function getStoredVariations(a) {
      var b = this.storage.read();
      if (!b.ok) return b;
      var c = b.data[a];
      return c ? (0, _tsRes.Ok)(c) : (0, _tsRes.Err)(new _kameleoonError.KameleoonError(_kameleoonError.KameleoonException.StorageRead, a));
    }
  }, {
    key: "getVariation",
    value: function getVariation(a) {
      var b = a.visitorCode,
        c = a.visitorIdentifier,
        d = a.featureFlag,
        e = a.targetingData,
        f = a.packageInfo,
        g = a.clientConfiguration,
        h = a.dataManager,
        _a$track = a.track,
        i = _a$track === void 0 ? !0 : _a$track,
        _a$withAssignment = a.withAssignment,
        j = _a$withAssignment === void 0 ? !1 : _a$withAssignment;
      _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: VariationConfiguration.getVariation(visitorCode: ", ", visitorIdentifier: ", ", featureFlag: ", ", targetingData: ", ", packageInfo: ", ", clientConfiguration, dataManager, withAssignment: ", ")"])), b, c, d, e, f, j);
      var k = d.rules,
        l = d.featureKey,
        m = d.id,
        n = d.defaultVariationKey;
      var _iterator2 = _createForOfIteratorHelper(k),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _o = _step2.value;
          var _a = _o.segment,
            _k = _o.experimentId,
            p = _o.id,
            q = _o.exposition,
            r = _o.respoolTime,
            s = _o.variationByExposition,
            t = this.getForcedExperimentVariation(b, _o.experimentId);
          var u = null;
          if (t.ok && (u = t.data, u && u.forceTargeting)) {
            _logging.KameleoonLogger.info(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["Visitor ", " has been forced targeted for ", ""])), b, _o);
            var _a2 = this.createAndSaveForcedTargetedVariation(b, d, _o, u, i, j);
            return _logging.KameleoonLogger.debug(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getVariation(visitorCode: ", ", visitorIdentifier: ", ", featureFlag: ", ", targetingData: ", ", packageInfo: ", ", clientConfiguration, dataManager, withAssignment: ", ") -> (targetedVariation: ", ")"])), b, c, d, e, f, j, _a2), (0, _tsRes.Ok)(_a2);
          }
          var v = _utilities.Utilities.checkTargeting({
            segment: _a,
            visitorCode: b,
            experimentId: _k,
            targetingData: e,
            packageInfo: f,
            clientConfiguration: g,
            dataManager: h,
            variationConfiguration: this
          });
          if (!v.ok) return _logging.KameleoonLogger.debug(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getVariation(visitorCode: ", ", visitorIdentifier: ", ", featureFlag: ", ", targetingData: ", ", packageInfo: ", ", clientConfiguration, dataManager, withAssignment: ", ") -> (targetedVariation: ", ")"])), b, c, d, e, f, j, v), v;
          if (!v.data) continue;
          if (_logging.KameleoonLogger.info(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["Visitor ", " has been targeted for ", ""])), b, _o), u) {
            var _a3 = this.createAndSaveForcedTargetedVariation(b, d, _o, u, i, j);
            return _logging.KameleoonLogger.debug(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getVariation(visitorCode: ", ", visitorIdentifier: ", ", featureFlag: ", ", targetingData: ", ", packageInfo: ", ", clientConfiguration, dataManager, withAssignment: ", ") -> (targetedVariation: ", ")"])), b, c, d, e, f, j, _a3), (0, _tsRes.Ok)(_a3);
          }
          var w = _hasher.Hasher.getHashDouble({
            visitorIdentifier: c,
            respoolTime: r,
            id: p + ""
          });
          if (_logging.KameleoonLogger.debug(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["Calculated ruleHash: ", " for visitorCode: ", ""])), w, b), w <= q) {
            var _a4 = 0;
            var _g = _hasher.Hasher.getHashDouble({
              visitorIdentifier: c,
              respoolTime: r,
              id: _k + ""
            });
            _logging.KameleoonLogger.debug(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["Calculated variationHash: ", " for visitorCode: ", ""])), _g, b);
            var _iterator3 = _createForOfIteratorHelper(s),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var _h = _step3.value;
                if (_a4 += _h.exposition, _g <= _a4) {
                  j && this.updateStoredVariations(b, _defineProperty2({}, _k, {
                    variationId: _h.variationId,
                    isTargetedRule: _o.type === _types.RuleType.TARGETED_DELIVERY,
                    status: i ? _types2.TrackingStatus.Unsent : _types2.TrackingStatus.Sent
                  }));
                  var _a5 = _h.exposition,
                    _g2 = _objectWithoutProperties(_h, _excluded),
                    _n = _objectSpread(_objectSpread({}, _g2), {}, {
                      rule: _o,
                      featureFlagId: m,
                      featureKey: l,
                      experimentId: _k,
                      isTargetedRule: _o.type === _types.RuleType.TARGETED_DELIVERY
                    });
                  return _logging.KameleoonLogger.debug(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getVariation(visitorCode: ", ", visitorIdentifier: ", ", featureFlag: ", ", targetingData: ", ", packageInfo: ", ", clientConfiguration, dataManager, withAssignment: ", ") -> (targetedVariation: ", ")"])), b, c, d, e, f, j, _n), (0, _tsRes.Ok)(_n);
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
          if (_o.type === _types.RuleType.TARGETED_DELIVERY) {
            var _a6 = {
              featureKey: l,
              featureFlagId: m,
              experimentId: null,
              variationKey: n,
              variationId: null,
              rule: null,
              isTargetedRule: !0
            };
            return _logging.KameleoonLogger.debug(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getVariation(visitorCode: ", ", visitorIdentifier: ", ", featureFlag: ", ", targetingData: ", ", packageInfo: ", ", clientConfiguration, dataManager, withAssignment: ", ") -> (targetedVariation: ", ")"])), b, c, d, e, f, j, _a6), (0, _tsRes.Ok)(_a6);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var o = {
        featureKey: l,
        featureFlagId: m,
        experimentId: null,
        variationKey: n,
        variationId: null,
        rule: null,
        isTargetedRule: !1
      };
      return _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getVariation(visitorCode: ", ", visitorIdentifier: ", ", featureFlag: ", ", targetingData: ", ", packageInfo: ", ", clientConfiguration, dataManager, withAssignment: ", ") -> (targetedVariation: ", ")"])), b, c, d, e, f, j, o), (0, _tsRes.Ok)(o);
    }
  }, {
    key: "createAndSaveForcedTargetedVariation",
    value: function createAndSaveForcedTargetedVariation(a, b, c, d, e, f) {
      var g = {
        variationKey: d.varByExp.variationKey,
        variationId: d.varByExp.variationId,
        rule: c,
        featureFlagId: b.id,
        featureKey: b.featureKey,
        experimentId: c.experimentId,
        isTargetedRule: c.type === _types.RuleType.TARGETED_DELIVERY
      };
      return f && this.updateStoredVariations(a, _defineProperty2({}, c.experimentId, {
        variationId: g.variationId,
        isTargetedRule: c.type === _types.RuleType.TARGETED_DELIVERY,
        status: e ? _types2.TrackingStatus.Unsent : _types2.TrackingStatus.Sent
      })), g;
    }
  }, {
    key: "updateStoredVariations",
    value: function updateStoredVariations(a, b) {
      _logging.KameleoonLogger.debug(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["CALL: VariationConfiguration.updateStoredVariations(visitorCode: ", ", variationData: ", ")"])), a, b);
      var c = this.storage.read();
      if (!c.ok) return _logging.KameleoonLogger.debug(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.updateStoredVariations(visitorCode: ", ", variationData: ", ") -> (result: ", ")"])), a, b, c), c;
      var d = c.data;
      for (var _c in d[a] || (d[a] = {}), b) d[a][_c] = b[_c];
      var e = this.storage.write(d);
      return _logging.KameleoonLogger.debug(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.updateStoredVariations(visitorCode: ", ", variationData: ", ") -> (resultWrite: ", ")"])), a, b, e), e;
    }
  }, {
    key: "getVariationData",
    value: function getVariationData(a, b) {
      var c = this.getStoredVariations(a);
      if (!c.ok) return [];
      var d = [];
      for (var _i = 0, _Object$entries = Object.entries(c.data); _i < _Object$entries.length; _i++) {
        var _ref = _Object$entries[_i];
        var _ref2 = _slicedToArray(_ref, 2);
        var e = _ref2[0];
        var f = _ref2[1];
        b(f.status) && d.push({
          experimentId: +e,
          variationId: f.variationId,
          isTargetedRule: f.isTargetedRule
        });
      }
      return d;
    }
  }, {
    key: "updateForcedExperimentVariation",
    value: function updateForcedExperimentVariation(a, b, c) {
      _logging.KameleoonLogger.debug(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["CALL: VariationConfiguration.updateForcedExperimentVariation(visitorCode: ", ", experimentId: ", ", forcedExperimentVariation: ", ")"])), a, b, c);
      var d = this.storageForcedExperimentVariations.read();
      if (!d.ok) return _logging.KameleoonLogger.debug(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.updateForcedExperimentVariation(visitorCode: ", ", experimentId: ", ", forcedExperimentVariation: ", ") -> (result: ", ")"])), a, b, c, d), d;
      var e = d.data;
      e[a] || (e[a] = {}), c ? e[a][b] = c : delete e[a][b];
      var f = this.storageForcedExperimentVariations.write(e);
      return _logging.KameleoonLogger.debug(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.updateForcedExperimentVariation(visitorCode: ", ", experimentId: ", ", forcedExperimentVariation: ", ") -> (resultWrite: ", ")"])), a, b, c, f), f;
    }
  }, {
    key: "updateForcedFeatureVariations",
    value: function updateForcedFeatureVariations(a, b) {
      _logging.KameleoonLogger.debug(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["CALL: VariationConfiguration.updateForcedFeatureVariations(visitorCode: ", ", forcedFeatureVariations: ", ")"])), a, b);
      var c = this.storageForcedFeatureVariations.read();
      if (!c.ok) return _logging.KameleoonLogger.debug(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.updateForcedFeatureVariations(visitorCode: ", ", forcedFeatureVariations: ", ") -> (result: ", ")"])), a, b, c), c;
      var d = c.data;
      d[0] || (d[0] = {}), d[1] || (d[1] = {});
      var e = d[0],
        f = d[1];
      e[a] || (e[a] = {}), f[a] || (f[a] = {}), b.forEach(function (b) {
        var c = b.simulated ? f[a] : e[a];
        c[b.featureKey] = b;
      });
      var g = this.storageForcedFeatureVariations.write(d);
      return _logging.KameleoonLogger.debug(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.updateForcedFeatureVariations(visitorCode: ", ", forcedFeatureVariations: ", ") -> (resultWrite: ", ")"])), a, b, g), g;
    }
  }, {
    key: "clearSimulatedVariations",
    value: function clearSimulatedVariations(a) {
      var b;
      _logging.KameleoonLogger.debug(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["CALL: VariationConfiguration.clearSimulatedVariations(visitorCode: ", ")"])), a);
      var c = this.storageForcedFeatureVariations.read();
      if (!c.ok) return _logging.KameleoonLogger.debug(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.clearSimulatedVariations(visitorCode: ", ") -> (result: ", ")"])), a, c), c;
      var d;
      var e = c.data;
      return null !== e && void 0 !== e && null !== (b = e[1]) && void 0 !== b && b[a] ? (delete e[1][a], d = this.storageForcedFeatureVariations.write(e)) : d = (0, _tsRes.Ok)(), _logging.KameleoonLogger.debug(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.clearSimulatedVariations(visitorCode: ", ") -> (resultWrite: ", ")"])), a, d), d;
    }
  }, {
    key: "getForcedFeatureVariation",
    value: function getForcedFeatureVariation(a, b) {
      var c, d, e, f;
      _logging.KameleoonLogger.debug(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["CALL: VariationConfiguration.getForcedFeatureVariation(visitorCode: ", ", featureKey: ", ")"])), a, b);
      var g = this.storageForcedFeatureVariations.read();
      if (!g.ok) return _logging.KameleoonLogger.debug(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getForcedFeatureVariation(visitorCode: ", ", featureKey: ", ") -> (simulatedResult: ", ")"])), a, b, g), g;
      var h = null === (c = g.data[1]) || void 0 === c || null === (d = c[a]) || void 0 === d ? void 0 : d[b];
      if (h) return _logging.KameleoonLogger.debug(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getForcedFeatureVariation(visitorCode: ", ", featureKey: ", ") -> (simulatedData: ", ")"])), a, b, h), (0, _tsRes.Ok)(h);
      var i = null === (e = g.data[0]) || void 0 === e || null === (f = e[a]) || void 0 === f ? void 0 : f[b];
      return _logging.KameleoonLogger.debug(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getForcedFeatureVariation(visitorCode: ", ", featureKey: ", ") -> (forcedData: ", ")"])), a, b, i), (0, _tsRes.Ok)(i);
    }
  }, {
    key: "getForcedExperimentVariation",
    value: function getForcedExperimentVariation(a, b) {
      var c;
      _logging.KameleoonLogger.debug(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["CALL: VariationConfiguration.getForcedExperimentVariation(visitorCode: ", ", experimentId: ", ")"])), a, b);
      var d = this.storageForcedExperimentVariations.read();
      if (!d.ok) return _logging.KameleoonLogger.debug(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getForcedExperimentVariation(visitorCode: ", ", experimentId: ", ") -> (forcedResult: ", ")"])), a, b, d), d;
      var e = null === (c = d.data[a]) || void 0 === c ? void 0 : c[b];
      return _logging.KameleoonLogger.debug(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.getForcedExperimentVariation(visitorCode: ", ", experimentId: ", ") -> (forcedExperiment: ", ")"])), a, b, e), (0, _tsRes.Ok)(e);
    }
  }, {
    key: "parseForcedVariationData",
    value: function parseForcedVariationData(a) {
      var b = !!(1 < arguments.length && void 0 !== arguments[1]) && arguments[1];
      var c = this.clientConfiguration.featureFlags.get(a.featureKey);
      if (!c) return _logging.KameleoonLogger.error(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["Simulated feature flag '", "' not found"])), a.featureKey), null;
      var d = null;
      if (0 === a.experimentId) return d = {
        featureKey: a.featureKey,
        rule: null,
        varByExp: null,
        simulated: b
      }, d;
      var _iterator4 = _createForOfIteratorHelper(c.rules),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var e = _step4.value;
          if (a.experimentId !== e.experimentId) continue;
          var _c2 = e.variationByExposition.find(function (b) {
            return b.variationId === a.variationId;
          });
          if (_c2) return d = {
            featureKey: a.featureKey,
            rule: {
              type: e.type,
              experimentId: e.experimentId
            },
            varByExp: {
              variationKey: _c2.variationKey,
              variationId: _c2.variationId
            },
            simulated: b
          }, d;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return _logging.KameleoonLogger.error(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["Simulated variation ", " not found"])), a.variationId), null;
    }
  }, {
    key: "simulatedVariationFromJson",
    value: function simulatedVariationFromJson(a, b) {
      if (_logging.KameleoonLogger.debug(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["CALL: VariationConfiguration.simulatedVariationFromJson(featureKey: ", ", data: ", ")"])), a, b), !this.isSimulatedVariationJson(b)) return null;
      var c = this.parseForcedVariationData({
        featureKey: a,
        variationId: b.varId,
        experimentId: b.expId
      }, !0);
      return _logging.KameleoonLogger.debug(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["RETURN: VariationConfiguration.simulatedVariationFromJson(featureKey: ", ", data: ", ") -> (forcedVariation: ", ")"])), a, b, c), c;
    }
  }, {
    key: "isSimulatedVariationJson",
    value: function isSimulatedVariationJson(a) {
      return a && ("number" == typeof a.expId || null === a.expId);
    }
  }]);
}();
exports.VariationConfiguration = VariationConfiguration;